import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { CompanyFacade, CompanyService, NotificationFacade } from '@ridango/components';
import { AuthService, Company, BaseComponent, LogService } from '@ridango/core';
import Env from '@ridango/core/env';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { CompanyNgrxService } from '@ridango/components/lib/company-ngrx/company.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    templateUrl: './account-company-edit-page.component.html'
})
export class AccountCompanyEditPageComponent extends BaseComponent implements OnInit, OnDestroy {
    constructor(
        @Inject('ENV') public environment: Env,
        private companyFacade: CompanyFacade,
        private notification: NotificationFacade,
        private route: ActivatedRoute,
        private authService: AuthService,
        private companyNgrxService: CompanyNgrxService,
        private companyService: CompanyService,
        private ls: LogService,
        private translate: TranslateService
    ) {
        super();
    }

    company$: Observable<Company> = this.companyFacade.selectedCompany$;
    loaded$: Observable<boolean> = this.companyFacade.loaded$;
    companyId: string;

    companyForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        vatNumber: new FormControl(''),
        registryNumber: new FormControl('', [Validators.required]),
        address: new FormControl('', [Validators.required]),
        city: new FormControl('', [Validators.required]),
        postalCode: new FormControl('', [Validators.required]),
        contactName: new FormControl('', [Validators.required]),
        contactEmail: new FormControl('', [Validators.required, Validators.email]),
        contactPhone: new FormControl('', [Validators.required])
    });

    isNewCompany = false;

    ngOnInit() {
        this.companyId = this.authService.getLoggedInUserCompanyId();
        this.route.url
            .pipe(
                switchMap((url) => {
                    if (url.length > 0 && !url[0].path.includes('add-company')) {
                        return this.companyNgrxService.fetchCompany(this.companyId);
                    } else {
                        this.isNewCompany = true;
                        return of(null);
                    }
                }),
                filter((company) => !!company),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe((company) => {
                this.companyFacade.setSelectedCompany(company);
                this.companyForm.patchValue(company);
            });
    }

    submitCompany() {
        if (this.companyForm.valid) {
            if (this.isNewCompany) {
                this.companyFacade.saveCompanyProfile(this.companyForm.value);
            } else {
                this.companyNgrxService.updateCompanyProfile(this.companyForm.value, this.companyId).subscribe(
                    (d) => {
                        this.companyService.setSelectedCompany(d);
                        this.notification.success(this.translate.instant('LOCAL_COMPANY_PROFILE_UPDATED_SUCCESS'));
                    },
                    (e) => {
                        this.ls.log(this, 'submitCompany', e);
                        this.notification.error(this.translate.instant(e.error));
                    }
                );
            }
        } else {
            this.notification.error(this.translate.instant('COMPANY_FORM_ALL_FIELDS_REQUIRED'));
        }
    }
}
